/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { map } from 'lodash';
import { css, StyleSheet } from 'aphrodite';
import { SectionHeader } from 'blb-components/AuthenticatedApp/DashboardPage/SectionHeader';
import { cardWidth, wideCardWidth } from 'blb-styles/constants';
import { DashboardSectionItem } from 'blb-components/AuthenticatedApp/DashboardPage/DashboardSectionItem';

export const styles = StyleSheet.create({
  headerBarContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: cardWidth,
  },
  headerContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 16,
  },
  sectionContentContainer: {
    marginBottom: 48,
  },
  title: {
    marginRight: '8px',
  },
  wideHeaderBarContainer: {
    maxWidth: wideCardWidth,
  },
});

export namespace DashboardSection {
  export interface Props {
    headerActions?: React.ReactNode;
    sectionConfigs: DashboardSectionItem.SectionConfig[];
    sectionHeader: string;
    wideCard?: boolean;
  }
}

export const DashboardSection: React.FC<DashboardSection.Props> = ({
  sectionHeader,
  sectionConfigs,
  headerActions,
  wideCard,
}) => {
  return (
    <>
      <div className={css(styles.headerBarContainer, wideCard && styles.wideHeaderBarContainer)}>
        <SectionHeader text={sectionHeader} />
        {headerActions}
      </div>
      {map(sectionConfigs, sectionConfig => (
        <DashboardSectionItem key={sectionConfig.title} sectionConfig={sectionConfig} />
      ))}
    </>
  );
};
